angular.module('rjmNg.directives').directive "connectionEditor", [
  () ->
    restrict: "E"
    templateUrl: "directive.connectionEditor.html"
    replace: true
    scope: {}
    controllerAs: "view"
    bindToController: true
    controller: [
      "$routeParams"
      "connectionUtils"
      (
        $routeParams
        connectionUtils
      ) ->

        view = @

        view.connectionType = connectionUtils.getTypeFromRoute($routeParams.connectionType)
        view.useIntegrationDirective = connectionUtils.getUIConfig(view.connectionType)?.useIntegrationDirective
        view.hideDefaultHeader = connectionUtils.getUIConfig(view.connectionType)?.hideDefaultHeader or false

        view
    ]

]
